import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  redirectTo?: string;
}

export function ProtectedRoute({ 
  children, 
  requiredRole, 
  redirectTo = '/login' 
}: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Показываем загрузку пока проверяем авторизацию
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Проверка авторизации...</p>
        </div>
      </div>
    );
  }

  // Если пользователь не авторизован, перенаправляем на страницу входа
  if (!user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Если требуется определенная роль и у пользователя её нет
  if (requiredRole && user.role !== requiredRole) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive mb-2">Доступ запрещен</h1>
          <p className="text-muted-foreground mb-4">
            У вас недостаточно прав для доступа к этой странице.
          </p>
          <p className="text-sm text-muted-foreground">
            Требуется роль: {requiredRole}, ваша роль: {user.role}
          </p>
        </div>
      </div>
    );
  }

  // Если все проверки пройдены, показываем защищенный контент
  return <>{children}</>;
}
